import { localStorageHelper } from './localStorage';

const TOKEN_STORAGE_KEY = 'apiToken';

let token: string | null = null;

function getAuthToken(): string | null {
  return token || localStorageHelper.getItem(TOKEN_STORAGE_KEY);
}

function setAuthToken(value: string) {
  token = value;
  localStorageHelper.setItem(TOKEN_STORAGE_KEY, value);
}

export { getAuthToken, setAuthToken };
